import { useEffect, useState } from "react";
import { Collapse } from "@mantine/core";
import { GoChevronDown } from "react-icons/go";
import { NavLink, To, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

type Props = {
  title: string;
  icon: string;
  active?: boolean;
  isOpened: boolean;
  to?: To;
  childRoutes?: string[];
  sidebarOpen?: boolean;
  children?: React.ReactNode;
};

const SidebarTile = ({
  title,
  icon,
  active = false,
  isOpened,
  to,
  childRoutes,
  sidebarOpen,
  ...props
}: Props) => {
  const navigate = useNavigate();
  const [opened, setOpen] = useState(false);
  const location = useLocation();
  const width = "calc(100%-1.5vh)";

  // const title = t(`sidebar.${receivedTitle.toLowerCase()}`)

  useEffect(() => {
    try {
      if (childRoutes?.includes(location.pathname)) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    } catch (e) {}
  }, [childRoutes, location]);

  return (
    <>
      {props.children ? (
        <>
          <div
            style={{ width: width }}
            onClick={() => {
              setOpen((prev) => {
                if (childRoutes) {
                  if (childRoutes.includes(location.pathname)) {
                    return !prev;
                  } else {
                    navigate(childRoutes[0]);
                    return true;
                  }
                } else {
                  return !prev;
                }
              });
            }}
            className={`sidebar-tile px-3 py-2 mb-3 ${
              childRoutes?.includes(location.pathname) ? "active" : ""
            }`}
          >
            <div className="d-flex align-items-center">
              <img alt="" src={icon} className="sidebar-leading-icon my-auto" />
              {isOpened && <p className="sidebar-menu my-auto ms-2">{title}</p>}
            </div>
            {props.children && (
              <GoChevronDown
                style={{
                  transform: opened ? "rotate(-180deg)" : "rotate(0deg)",
                  transition: "0.25s transform ease-in-out",
                }}
              />
            )}
          </div>
          <Collapse in={opened}>
            <div className={`ps-${isOpened ? "4" : "3"}`}>{props.children}</div>
          </Collapse>
        </>
      ) : (
        <NavLink
          to={to!}
          style={{ width: width }}
          className={({ isActive }) =>
            [
              "text-decoration-none sidebar-tile px-3 py-2 mb-3",
              isActive ? "active" : null,
            ]
              .filter(Boolean)
              .join(" ")
          }
        >
          <div className="d-flex align-items-center">
            <img alt="" src={icon} className="sidebar-leading-icon my-auto" />
            {isOpened && <p className="sidebar-menu my-auto ms-2">{title}</p>}
          </div>
        </NavLink>
      )}
    </>
  );
};

export default SidebarTile;
